import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { APPROVALS } from "helpers/url_helper"
import { HRConfig } from "helpers/backend_helper"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () =>{
    setLoading(true);
    try {
      const obj = JSON.parse(localStorage.getItem("authMildUser"));
      const navUserName =  obj.username 
      const CompanyID = obj.activeCompany
      axios.get(APPROVALS + "?$filter=approverId eq '"+ navUserName +"' and Status eq 'Open'&company="+CompanyID, HRConfig)
          .then((response)=>{
            setApprovals(response.data.value)
          })
          .catch((error)=>{
            console.log(error)
          });
    } catch (error) {
      console.error(error.message);
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">{approvals.length}</span>
        </DropdownToggle>
        {(approvals.length > 0) && (
        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
            </Row>
          </div>
     
          
          <SimpleBar style={{ height: "230px" }}>
          {(approvals.length > 0) && approvals.map((item,key) => (
                  <Link to="/approvals/" className="text-reset notification-item" key={key} >
                    <div className="media">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-bell" />
                        </span>
                      </div>
                      <div className="media-body">
                        <h6 className="mt-0 mb-1"> {item.documentNo} </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">
                            {item.employeeName}
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {item.dateTimeSentforApproval}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  ))} 
          </SimpleBar>
          
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/approvals"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              View all
            </Link>
          </div>
        </DropdownMenu>
        )}
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}